<template>
    <div :class="[$style.LineChart, classes]">
        <div :class="$style.line"
             :style="{ ['--value']: `${value}%` }"
        />
        <div v-if="showValue"
             :class="$style.value"
        >
            {{ value }}%
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        color: {
            type: String,
            default: 'green',
            validate: (value) => ['green', 'blue'].includes(value),
        },

        showValue: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Number,
            default: 0,
        },
    })
    const $style = useCssModule()
    const classes = computed(() => ({
        [$style[`_${props.color}`]]: props.color,
    }))
</script>

<style
    lang="scss"
    module
>
    .LineChart {
        display: flex;
        flex-flow: column;

        &._green {
            .line {
                &:after {
                    background-color: var(--green-800);
                }
            }
        }

        &._blue {
            .line {
                &:after {
                    background-color: var(--blue-600);
                }
            }
        }
    }

    .line {
        position: relative;
        width: 100%;
        height: 20px;
        background-color: var(--blue-200);

        &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: var(--value);
            height: 100%;
            transition: width $default-transition;
        }
    }

    .value {
        margin-top: 8px;
        font-size: 16px;
        line-height: 1;

        @include respond-to(mobile) {
            margin-left: auto;
        }
    }
</style>
